var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.length === 0 || _vm.data[0].y === 0)?_c('span',{staticClass:"height-400 d_flex"},[_c('b',[_vm._v("No data to display")])]):_c('highcharts',{ref:"chart",attrs:{"options":_vm.options.chart}})}
var staticRenderFns = []

export { render, staticRenderFns }